import { render, staticRenderFns } from "./userProfile.vue?vue&type=template&id=34f2e06c&scoped=true"
import script from "./userProfile.vue?vue&type=script&lang=js"
export * from "./userProfile.vue?vue&type=script&lang=js"
import style0 from "./userProfile.vue?vue&type=style&index=0&id=34f2e06c&prod&lang=scss&scoped=true"
import style1 from "./userProfile.vue?vue&type=style&index=1&id=34f2e06c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f2e06c",
  null
  
)

export default component.exports